import { ROUTES } from "@/constants/routes"
import { 
  ipMiddleware, 
  loginMiddleware, 
  teacherMiddleware, 
  studentJustMiddleware,
  reserveStudentMiddleware,//학생 모의면접 참여 가능 여부
} from "./_middleware"
import {
  documentInterviewMiddleware,
  interviewEntryMiddleware,
} from "./interviewAccess"

const documentBeforeEnter = [loginMiddleware, documentInterviewMiddleware]
const loginBeforeEnter = [loginMiddleware]

export const interviewRoutes = [
  {
    path: "/interview",
    name: ROUTES.INTERVIEW.INDEX,
    beforeEnter: [loginMiddleware, interviewEntryMiddleware],
  },
  {
    path: "/interview/interview",
    name: ROUTES.INTERVIEW.INTERVIEW,
    component: () => import("@/views/interview/Interview.vue"),
    meta: { layout: "PlainLayout" },
    beforeEnter: [ipMiddleware, loginMiddleware],
  },
  {
    path: "/interview/document",
    name: ROUTES.INTERVIEW.DOCUMENT_ROOT,
    component: () => import("@/views/interview/Notice.vue"),
    meta: { interviewMode: "mode_01" },
    beforeEnter: documentBeforeEnter,
  },
  {
    path: "/interview/document/test",
    name: ROUTES.INTERVIEW.DOCUMENT_TEST,
    component: () => import("@/views/interview/Test.vue"),
    meta: { interviewMode: "mode_01" },
    beforeEnter: documentBeforeEnter,
  },
  {
    path: "/interview/document/setup",
    name: ROUTES.INTERVIEW.DOCUMENT_SETUP,
    component: () => import("@/views/interview/document/Index.vue"),
    meta: { interviewMode: "mode_01" },
    beforeEnter: documentBeforeEnter,
  },
  {
    path: "/interview/document/session",
    name: ROUTES.INTERVIEW.DOCUMENT_SESSION,
    component: () => import("@/views/interview/Interview.vue"),
    meta: { layout: "PlainLayout", interviewMode: "mode_01" },
    beforeEnter: documentBeforeEnter,
  },
  {
    path: "/interview/document/report",
    name: ROUTES.INTERVIEW.DOCUMENT_REPORT,
    component: () => import("@/views/interview/document/Report.vue"),
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/general",
    name: ROUTES.INTERVIEW.GENERAL_ROOT,
    component: () => import("@/views/interview/Notice.vue"),
    meta: { interviewMode: "mode_02" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/general/test",
    name: ROUTES.INTERVIEW.GENERAL_TEST,
    component: () => import("@/views/interview/Test.vue"),
    meta: { interviewMode: "mode_02" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/general/session",
    name: ROUTES.INTERVIEW.GENERAL_SESSION,
    component: () => import("@/views/interview/Interview.vue"),
    meta: { layout: "PlainLayout", interviewMode: "mode_02" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/statement",
    name: ROUTES.INTERVIEW.STATEMENT_ROOT,
    component: () => import("@/views/interview/Notice.vue"),
    meta: { interviewMode: "mode_03" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/statement/test",
    name: ROUTES.INTERVIEW.STATEMENT_TEST,
    component: () => import("@/views/interview/Test.vue"),
    meta: { interviewMode: "mode_03" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/statement/setup",
    name: ROUTES.INTERVIEW.STATEMENT_SETUP,
    component: () => import("@/views/interview/statement/Index.vue"),
    meta: { interviewMode: "mode_03" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/statement/session",
    name: ROUTES.INTERVIEW.STATEMENT_SESSION,
    component: () => import("@/views/interview/Interview.vue"),
    meta: { layout: "PlainLayout", interviewMode: "mode_03" },
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/statement/report",
    name: ROUTES.INTERVIEW.STATEMENT_REPORT,
    component: () => import("@/views/interview/statement/Report.vue"),
    beforeEnter: loginBeforeEnter,
  },
  {
    path: "/interview/interviewer",
    name: ROUTES.INTERVIEW.INTERVIEWER,
    component: () => import("@/views/interview/Interviewer.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware],
  },
  {
    path: "/interview/reservation",
    name: ROUTES.INTERVIEW.RESERVATION_INDEX,
    component: () => import("@/views/interview/reservation/Index.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, teacherMiddleware],
  },
  {
    path: "/interview/reservation/apply",
    name: ROUTES.INTERVIEW.RESERVATION_APPLY,
    component: () => import("@/views/interview/reservation/Apply.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, teacherMiddleware],
  },
  {
    path: "/interview/reservation/history",
    name: ROUTES.INTERVIEW.RESERVATION_HISTORY,
    component: () => import("@/views/interview/reservation/History.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, teacherMiddleware],
  },
  {
    path: "/interview/studentreservation",
    name: ROUTES.INTERVIEW.STUDENTRESERVATION,
    component: () => import("@/views/interview/reservation/Index.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, studentJustMiddleware, reserveStudentMiddleware],
  },
  {
    path: "/interview/studentreservation/notice",
    name: ROUTES.INTERVIEW.STUDENTRESERVATION_NOTICE,
    component: () => import("@/views/interview/Notice.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, studentJustMiddleware, reserveStudentMiddleware],
  },
  {
    path: "/interview/studentreservation/test",
    name: ROUTES.INTERVIEW.STUDENTRESERVATION_TEST,
    component: () => import("@/views/interview/Test.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, studentJustMiddleware, reserveStudentMiddleware],
  },
  {
    path: "/interview/studentreservation/intro",
    name: ROUTES.INTERVIEW.STUDENTRESERVATION_INTRO,
    component: () => import("@/views/interview/document/Intro.vue"),
    beforeEnter: [ipMiddleware, loginMiddleware, studentJustMiddleware, reserveStudentMiddleware],
  },
]
